import { LanguageHelper } from '@/hooks/use-language-helper';
import { HeaderFormat, SPORTS_MENU } from '@/types/result-setting';


const getResultIndexHeaderFormat = (languageHelper: LanguageHelper) => (data: any, sportId: SPORTS_MENU) => {
	const getHeaderFormatFunc = Header_Format_Mapping(languageHelper)[sportId];
	const header = getHeaderFormatFunc ? getHeaderFormatFunc(false) : Header_Format_Mapping(languageHelper)[SPORTS_MENU.Darts]?.(false);
	data.Header = header;
	data.lbl_today = languageHelper('Result')('lbl_today');
	data.lbl_yesterday = languageHelper('Result')('yesterday');
	data.lbl_noinfo = languageHelper('Result')('lbl_noinfo');
	data.LableNote = languageHelper('Result')('lbl_note');
	data.LableResultNote = '';
	data.lblDisTimeNote = '';
};

const getResultIndexMatchFormat = (languageHelper: LanguageHelper) => (data: any, sportId: SPORTS_MENU) => {
	if (!data.LeagueDic) return;

	const getMatchFormatFunc = Match_Format_Mapping(languageHelper)[sportId];
	if (getMatchFormatFunc) {
		Object.values(data.LeagueDic).forEach((league: any) => {
			Object.values(league.MatchDic).forEach((match: any) => {
				getMatchFormatFunc(match);
			});
		});
	}
};

const getOutrightIndexHeaderFormat = (languageHelper: LanguageHelper) => (data: any) => {
	if (data) {
		return {
			...data,
			Header: {
				Result: languageHelper('Result')('lbl_Result'),
				Team: '',
				Time: languageHelper('Result')('lbl_time'),
			},
			To: languageHelper('Result')('lbl_to'),
			lbl_noinfo: languageHelper('Result')('lbl_noinfo'),
			LableNote: languageHelper('Result')('lbl_note'),
			LableResultNote: '',
			lblDisTimeNote: '',
		};
	}
	return data;
}

const getResultDetailDataFormat = (languageHelper: LanguageHelper) => (data: any, sportId: SPORTS_MENU) => {
	const isEmpty = (value: any) => value === '' || value === null;
	if (data) {
		const headerFormatFunc = Detail_Header_Format_Mapping(languageHelper)[sportId];
		data.Header = headerFormatFunc ? headerFormatFunc(data) : undefined;
	}

	if (data.hasOwnProperty('IsPen') && data.IsPen) {
		data.Header.GoalSequence = languageHelper('Result')('lbl_PSSeq');
	}

	if (data.hasOwnProperty('HomeLiveScore') && data.hasOwnProperty('AwayLiveScore') && !isEmpty(data.HomeLiveScore) && !isEmpty(data.AwayLiveScore)) {
		data.Header.LiveScore = languageHelper('Result')('lbl_LiveScores');
	}

	console.log('1', data);
	return data;
}

const getResultPopupDataFormat = (languageHelper: LanguageHelper) => (data: any) => {
	if (!data) return;

	return data.map((item: any) => {
		const sportId: SPORTS_MENU = parseInt(item.SportID);

		/** 組裝外層Header */
		const getHeaderFormatFunc = Header_Format_Mapping(languageHelper)[sportId];
		const header = getHeaderFormatFunc
			? getHeaderFormatFunc(true)
			: Header_Format_Mapping(languageHelper)[SPORTS_MENU.Darts]?.();

		item.Header = header;

		/** 組裝DetailData Header */
		const detailDataKey = Detail_Data_Mapping[sportId as keyof typeof Detail_Data_Mapping];
		const enableDetailDataFormat = detailDataKey && Detail_Header_Format_Mapping(languageHelper)[sportId as keyof typeof Detail_Header_Format_Mapping];
		if (enableDetailDataFormat) getResultDetailDataFormat(languageHelper)(item.Detail[detailDataKey], sportId);

		/** 組裝FastMarket Data Header */
		if (item.Detail && item.Detail.FastMarketData) {
			const fastMarketData = item.Detail.FastMarketData;
			fastMarketData.Header = {
				Minutes: languageHelper('Result')('lbl_minutes')
			}
		}

		/** 組裝LiveCasino Data Header */
		if (item.Detail && item.Detail.LiveCasinoData) {
			const liveCasinoData = item.Detail.LiveCasinoData;
			liveCasinoData.Header = {
				BallNo: languageHelper('Result')('lbl_BallNo'),
				PlayerBanker: languageHelper('Result')('lbl_LiveCasino_PB'),
				GameResult: languageHelper('Result')('lbl_Result'),
				FirstHalfHomeScore: languageHelper('Result')('lbl_firsthalfscore'),
				HomeFinalScore: languageHelper('Result')('lbl_finalscore')
			}
		}

		return item;
	});
}

const Header_Format_Mapping = (languageHelper: LanguageHelper): { [key in SPORTS_MENU]?: (isPopup?: boolean) => HeaderFormat } => ({
	[SPORTS_MENU.Soccer]: (isPopup?: boolean) => Header_Format_Process.Soccer(languageHelper)(isPopup),
	[SPORTS_MENU.Basketball]: (isPopup?: boolean) => Header_Format_Process.Basketball(languageHelper)(isPopup),
	[SPORTS_MENU.Football]: (isPopup?: boolean) => Header_Format_Process.Football(languageHelper)(isPopup),
	[SPORTS_MENU.Rugby]: (isPopup?: boolean) => Header_Format_Process.Football(languageHelper)(isPopup),
	[SPORTS_MENU.Netball]: (isPopup?: boolean) => Header_Format_Process.Football(languageHelper)(isPopup),
	[SPORTS_MENU.IceHockey]: (isPopup?: boolean) => Header_Format_Process.IceHockey(languageHelper)(isPopup),
	[SPORTS_MENU.FieldHockey]: (isPopup?: boolean) => Header_Format_Process.IceHockey(languageHelper)(isPopup),
	[SPORTS_MENU.Tennis]: (isPopup?: boolean) => Header_Format_Process.Tennis(languageHelper)(isPopup),
	[SPORTS_MENU.Volleyball]: (isPopup?: boolean) => Header_Format_Process.Volleyball(languageHelper)(isPopup),
	[SPORTS_MENU.Squash]: (isPopup?: boolean) => Header_Format_Process.Squash(languageHelper)(isPopup),
	[SPORTS_MENU.SepakTakraw]: (isPopup?: boolean) => Header_Format_Process.SepakTakraw(languageHelper)(isPopup),
	[SPORTS_MENU.Baseball]: (isPopup?: boolean) => Header_Format_Process.Baseball(languageHelper)(isPopup),
	[SPORTS_MENU.Badminton]: (isPopup?: boolean) => Header_Format_Process.Badminton(languageHelper)(isPopup),
	[SPORTS_MENU.HorseRacing]: (isPopup?: boolean) => Header_Format_Process.HorseRacing(languageHelper)(isPopup),
	[SPORTS_MENU.Greyhounds]: (isPopup?: boolean) => Header_Format_Process.HorseRacing(languageHelper)(isPopup),
	[SPORTS_MENU.Harness]: (isPopup?: boolean) => Header_Format_Process.HorseRacing(languageHelper)(isPopup),
	[SPORTS_MENU.NumberGame]: (isPopup?: boolean) => Header_Format_Process.NumberGame(languageHelper)(isPopup),
	[SPORTS_MENU.LiveCasino]: (isPopup?: boolean) => Header_Format_Process.LiveCasino(languageHelper)(isPopup),
	[SPORTS_MENU.Handball]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.OtherSports]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.Kabaddi]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.Futsal]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.Lotto]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtuallySoccer]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualFootballCup]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualFootbalLeague]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccer]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualCockFighting]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccerLeague]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccerNation]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccerWorldCup]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccerAsianCup]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccerBundesliga]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccerChampionsCup]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSoccerEuroCup]: (isPopup?: boolean) => Header_Format_Process.Handball(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualHorseRacing]: (isPopup?: boolean) => Header_Format_Process.VirtualHorseRacing(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualGreyhounds]: (isPopup?: boolean) => Header_Format_Process.VirtualHorseRacing(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualMotorsports]: (isPopup?: boolean) => Header_Format_Process.VirtualHorseRacing(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualCycling]: (isPopup?: boolean) => Header_Format_Process.VirtualHorseRacing(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualDogs]: (isPopup?: boolean) => Header_Format_Process.VirtualDogs(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualHorses]: (isPopup?: boolean) => Header_Format_Process.VirtualDogs(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualSpeedway]: (isPopup?: boolean) => Header_Format_Process.VirtualSpeedway(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualTennis]: (isPopup?: boolean) => Header_Format_Process.VirtualTennis(languageHelper)(isPopup),
	[SPORTS_MENU.VirtualBasketball]: (isPopup?: boolean) => Header_Format_Process.VirtualBasketball(languageHelper)(isPopup),
	[SPORTS_MENU.ESports]: (isPopup?: boolean) => Header_Format_Process.ESports(languageHelper)(isPopup),
	[SPORTS_MENU.Happy5]: (isPopup?: boolean) => Header_Format_Process.Happy5(languageHelper)(isPopup),
	[SPORTS_MENU.Cricket]: (isPopup?: boolean) => Header_Format_Process.Cricket(languageHelper)(isPopup),
	[SPORTS_MENU.BeachVolleyball]: (isPopup?: boolean) => Header_Format_Process.BeachVolleyball(languageHelper)(isPopup),
	[SPORTS_MENU.Bitcoin]: (isPopup?: boolean) => Header_Format_Process.Bitcoin(languageHelper)(isPopup),
	[SPORTS_MENU.Bandy]: (isPopup?: boolean) => Header_Format_Process.Bandy(languageHelper)(isPopup),
	[SPORTS_MENU.Darts]: (isPopup?: boolean) => Header_Format_Process.Darts(languageHelper)(isPopup),
});

const Header_Format_Process = {
	Soccer: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		MatchName: languageHelper('Result')('Match'),
		FirstHalfScore: languageHelper('Result')('lbl_firsthalfscore'),
		FinalScore: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
		Selection: languageHelper('Result')('lbl_BB_Selection'),
		FinalResult: languageHelper('Result')('lbl_BB_FinalResult'),
	}),

	Basketball: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Q1: languageHelper('Result')('lbl_1Q'),
		Q2: languageHelper('Result')('lbl_2Q'),
		Q3: languageHelper('Result')('lbl_3Q'),
		Q4: languageHelper('Result')('lbl_4Q'),
		OT: languageHelper('Result')('lbl_OT'),
		FirstHalf: languageHelper('Result')('lbl_firsthalf'),
		SecondHalf: languageHelper('Result')('lbl_secondhalf'),
		Final: languageHelper('Result')('lbl_final'),
		Status: languageHelper('Result')('lbl_status'),
		Selection: languageHelper('Result')('lbl_BB_Selection'),
		FinalResult: languageHelper('Result')('lbl_BB_FinalResult'),
	}),

	Football: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Q1: languageHelper('Result')('lbl_1Q'),
		Q2: languageHelper('Result')('lbl_2Q'),
		Q3: languageHelper('Result')('lbl_3Q'),
		Q4: languageHelper('Result')('lbl_4Q'),
		OT: languageHelper('Result')('lbl_OT'),
		FirstHalf: languageHelper('Result')('lbl_firsthalfscore'),
		Final: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	IceHockey: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Period1: languageHelper('Result')('lbl_1period'),
		Period2: languageHelper('Result')('lbl_2period'),
		Period3: languageHelper('Result')('lbl_3period'),
		OT: languageHelper('Result')('lbl_OT'),
		Final: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	Tennis: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Set1: isPopup ? languageHelper('Result')('lbl_Tennis_S1') : languageHelper('Result')('lbl_Set_1'),
		Set2: isPopup ? languageHelper('Result')('lbl_Tennis_S2') : languageHelper('Result')('lbl_Set_2'),
		Set3: isPopup ? languageHelper('Result')('lbl_Tennis_S3') : languageHelper('Result')('lbl_Set_3'),
		Set4: isPopup ? languageHelper('Result')('lbl_Tennis_S4') : languageHelper('Result')('lbl_Set_4'),
		Set5: isPopup ? languageHelper('Result')('lbl_Tennis_S5') : languageHelper('Result')('lbl_Set_5'),
		Status: languageHelper('Result')('lbl_status'),
		TotalPoints: languageHelper('Result')('lbl_TotalGames'),
		TotalSet: languageHelper('Result')('lbl_totalset'),
	}),

	Volleyball: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Status: languageHelper('Result')('lbl_status'),
		Set1: languageHelper('Result')('lbl_Volley_S1'),
		Set2: languageHelper('Result')('lbl_Volley_S2'),
		Set3: languageHelper('Result')('lbl_Volley_S3'),
		Set4: languageHelper('Result')('lbl_Volley_S4'),
		Set5: languageHelper('Result')('lbl_Volley_S5'),
		TotalPoints: languageHelper('Result')('lbl_totalpointOther'),
		TotalSet: languageHelper('Result')('lbl_totalsetOther'),
	}),

	Squash: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Status: languageHelper('Result')('lbl_status'),
		Set1: languageHelper('Result')('lbl_Volley_S1'),
		Set2: languageHelper('Result')('lbl_Volley_S2'),
		Set3: languageHelper('Result')('lbl_Volley_S3'),
		Set4: languageHelper('Result')('lbl_Volley_S4'),
		Set5: languageHelper('Result')('lbl_Volley_S5'),
		TotalPoints: languageHelper('Result')('lbl_totalpointOther'),
		TotalSet: languageHelper('Result')('lbl_totalset'),
	}),

	SepakTakraw: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Status: languageHelper('Result')('lbl_status'),
		Set1: languageHelper('Result')('lbl_Tennis_S1'),
		Set2: languageHelper('Result')('lbl_Tennis_S2'),
		Set3: languageHelper('Result')('lbl_Tennis_S3'),
		Set4: languageHelper('Result')('lbl_Tennis_S4'),
		Set5: languageHelper('Result')('lbl_Tennis_S5'),
		TotalPoints: languageHelper('Result')('lbl_totalpointOther'),
		TotalSet: languageHelper('Result')('lbl_totalpointOther'),
	}),

	Baseball: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		P1: '1',
		P2: '2',
		P3: '3',
		P4: '4',
		P5: '5',
		P6: '6',
		P7: '7',
		P8: '8',
		P9: '9',
		Game1: languageHelper('Result')('lbl_G1'),
		Game2: languageHelper('Result')('lbl_G2'),
		Game3: languageHelper('Result')('lbl_G3'),
		Game4: languageHelper('Result')('lbl_G4'),
		Game5: languageHelper('Result')('lbl_G5'),
		Game6: languageHelper('Result')('lbl_G6'),
		Game7: languageHelper('Result')('lbl_G7'),
		TotalGame: languageHelper('Result')('lbl_TGames'),
		Final: languageHelper('Result')('lbl_final'),
		Runs: languageHelper('Result')('livescoreHeader_Runs'),
		Hits: languageHelper('Result')('moreTab_30'),
		EI: languageHelper('Result')('lbl_EI'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	Badminton: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Set1: languageHelper('Result')('lbl_Game_1'),
		Set2: languageHelper('Result')('lbl_Game_2'),
		Set3: languageHelper('Result')('lbl_Game_3'),
		Set4: languageHelper('Result')('lbl_Game_4'),
		Set5: languageHelper('Result')('lbl_Game_5'),
		Status: languageHelper('Result')('lbl_status'),
		TotalPoints: languageHelper('Result')('lbl_totalpointOther'),
		TotalSet: languageHelper('Result')('lbl_TotalGames'),
	}),

	HorseRacing: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		Result: languageHelper('Result')('lbl_Result'),
		Status: languageHelper('Result')('lbl_status'),
		Win: languageHelper('Result')('lbl_hr_Win'),
		Place: languageHelper('Result')('lbl_hr_Place'),
		NSW: languageHelper('Result')('lbl_hr_NSW'),
		VIC: languageHelper('Result')('lbl_hr_VIC'),
		SCR: languageHelper('Result')('lbl_SCR'),
	}),

	NumberGame: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Status: languageHelper('Result')('lbl_status'),
		FirstNo: languageHelper('Result')('lbl_numbergame_1st_no'),
		SecondNo: languageHelper('Result')('lbl_numbergame_2nd_no'),
		LastNo: languageHelper('Result')('lbl_numbergame_last_no'),
		KickoffSeq: '',
	}),

	LiveCasino: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		GameType: '',
		KickoffTime: '',
		PB: 'P - B',
		Status: languageHelper('Result')('lbl_status'),
		Result: languageHelper('Result')('lbl_Result'),
	}),

	Handball: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		FirstHalfScore: languageHelper('Result')('lbl_firsthalfscore'),
		Match: languageHelper('Result')('Match'),
		Final: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	VirtualHorseRacing: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		Result: languageHelper('Result')('lbl_Result'),
		Status: languageHelper('Result')('lbl_status'),
		Win: languageHelper('Result')('lbl_hr_Win'),
		Place: languageHelper('Result')('lbl_hr_Place'),
	}),

	VirtualDogs: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		FirstHalfScore: languageHelper('Result')('lbl_firsthalfscore'),
		Match: languageHelper('Result')('Match'),
		Final: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
		Result: languageHelper('Result')('lbl_Result'),
	}),

	VirtualSpeedway: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		Result: languageHelper('Result')('lbl_Result'),
		Status: languageHelper('Result')('lbl_status'),
		Win: languageHelper('Result')('lbl_hr_Win'),
	}),

	VirtualTennis: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Score: languageHelper('Result')('lbl_VTScore'),
		CorrectScore: languageHelper('Result')('lbl_CrctScore'),
		TotalPoints: languageHelper('Result')('lbl_VTTotalPoints'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	VirtualBasketball: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		MatchName: languageHelper('Result')('Match'),
		FirstHalfScore: languageHelper('Result')('lbl_firsthalfscore'),
		FinalScore: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	ESports: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Final: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	Happy5: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		BS: languageHelper('Result')('lbl_H5bs'),
		CB: languageHelper('Result')('lbl_H5cb'),
		Result: languageHelper('Result')('lbl_Result'),
		MOME: languageHelper('Result')('lbl_H5mome'),
		OE: languageHelper('Result')('lbl_H5oe'),
		S4: languageHelper('Result')('lbl_H5s4'),
		BSToolTip: languageHelper('Result')('lbl_BigSmallTitel'),
		OEToolTip: languageHelper('Result')('lbl_OddEvenTitel'),
		S4ToolTip: '',
		MOMEToolTip: '',
		CBToolTip: languageHelper('Result')('lbl_Combo'),
		Status: languageHelper('Result')('lbl_status'),
		Total: languageHelper('Result')('lbl_H5total'),
		Soccer5: languageHelper('Result')('lbl_Soccer5'),
		Soccer5ToolTip: languageHelper('Result')('lbl_Soccer5'),
	}),

	Cricket: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Final: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
		Inns1: languageHelper('Result')('lbl_CricketInn1'),
		Inns2: languageHelper('Result')('lbl_CricketInn2'),
	}),

	BeachVolleyball: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Status: languageHelper('Result')('lbl_status'),
		Set1: languageHelper('Result')('lbl_Volley_S1'),
		Set2: languageHelper('Result')('lbl_Volley_S2'),
		Set3: languageHelper('Result')('lbl_Volley_S3'),
		Set4: languageHelper('Result')('lbl_Volley_S4'),
		Set5: languageHelper('Result')('lbl_Volley_S5'),
		TotalPoints: languageHelper('Result')('lbl_totalpointOther'),
		TotalSet: languageHelper('Result')('lbl_totalsetOther'),
	}),

	Bitcoin: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		Date: 'date',
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Price: languageHelper('Result')('lbl_BTCResultPrice'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	Bandy: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		FirstHalfScore: languageHelper('Result')('lbl_firsthalfscore'),
		FinalScore: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
		FinalResult: languageHelper('Result')('lbl_BB_FinalResult'),
	}),

	Darts: (languageHelper: LanguageHelper) => (isPopup = false): HeaderFormat => ({
		KickoffTime: '',
		Match: languageHelper('Result')('Match'),
		Final: languageHelper('Result')('lbl_finalscore'),
		Status: languageHelper('Result')('lbl_status'),
		Selection: languageHelper('Result')('lbl_BB_Selection'),
		FinalResult: languageHelper('Result')('lbl_BB_FinalResult'),
	}),
};

const Match_Format_Mapping = (languageHelper: LanguageHelper): { [key in SPORTS_MENU]?: (match: any) => void } => ({
	[SPORTS_MENU.Baseball]: (match: any) => {
		match.HomeHits = match.HomeTotalHits;
		match.AwayHits = match.AwayTotalHits;
		match.Status = match.Status;
		delete match.HomeTotalHits;
		delete match.AwayTotalHits;
	},
});

const Detail_Header_Format_Mapping = (languageHelper: LanguageHelper): { [key in SPORTS_MENU]?: (match: any) => void } => ({
	[SPORTS_MENU.Soccer]: () => ({
		Away: languageHelper('Result')('lbl_away'),
		AwayTeamPlayerSentOff: languageHelper('BetType')('b214'),
		Corners: languageHelper('Result')('lbl_Corners'),
		CornerSequence: languageHelper('Result')('lbl_CornerSequence'),
		ExtraTime: languageHelper('Result')('lbl_ExtraTime'),
		Final: languageHelper('Result')('lbl_final'),
		FirstGoalMethod: languageHelper('BetType')('b424'),
		FirstGoalTime10Min: languageHelper('BetType')('b192'),
		FirstGoalTime15Min: languageHelper('BetType')('b193'),
		FirstHalf: languageHelper('Result')('lbl_firsthalfscore'),
		FirstLastCorners: languageHelper('Result')('lbl_FirstLastCorners'),
		FirstTenMinutes1X2: languageHelper('BetType')('b176'),
		GoalBfMinX: languageHelper('Result')('lbl_GoalBfMinX'),
		GoalScorerAnyTime: languageHelper('Result')('lbl_GoalScorerAnyTime'),
		GoalScorerFirst: languageHelper('Result')('lbl_GoalsScorerFirst'),
		GoalSequence: languageHelper('Result')('lbl_GoalsSequence'),
		H1AwayTeamPlayerSentOff: languageHelper('BetType')('b215'),
		H1HomeTeamPlayerSentOff: languageHelper('BetType')('b213'),
		H1PlayerSentOff: languageHelper('BetType')('b211'),
		Home: languageHelper('Result')('lbl_home'),
		HomeTeamPlayerSentOff: languageHelper('BetType')('b212'),
		LiveScore: '',
		Match: languageHelper('Result')('Match'),
		PlayerSentOff: languageHelper('BetType')('b210'),
		Status: languageHelper('Result')('lbl_status'),
		TMHDP_ScoreX: languageHelper('Result')('lbl_TMHDP_ScoreX'),
	}),

	[SPORTS_MENU.ESports]: () => ({
		Final: languageHelper('Result')('lbl_finalscore'),
		Match: languageHelper('Result')('Match'),
		Status: languageHelper('Result')('lbl_status'),
	}),

	[SPORTS_MENU.Basketball]: () => ({
		BetType: languageHelper('Result')('lbl_bettype'),
		LiveScore: '',
		Result: languageHelper('Result')('lbl_Result'),
	}),

	[SPORTS_MENU.Volleyball]: () => ({
		BetType: languageHelper('Result')('lbl_bettype'),
		Result: languageHelper('Result')('lbl_Result'),
	}),

	[SPORTS_MENU.Badminton]: () => ({
		BetType: languageHelper('Result')('lbl_bettype'),
		Result: languageHelper('Result')('lbl_Result'),
	}),

	[SPORTS_MENU.Cricket]: () => ({
		BetType: languageHelper('Result')('lbl_bettype'),
		Result: languageHelper('Result')('lbl_Result'),
	}),

	[SPORTS_MENU.VirtualBasketball]: () => ({
		BetType: languageHelper('Result')('lbl_bettype'),
		Result: languageHelper('Result')('lbl_Result'),
	}),
});

const Detail_Data_Mapping = {
	[SPORTS_MENU.Soccer]: 'SoccerData',
	[SPORTS_MENU.Basketball]: 'BasketBallData',
	[SPORTS_MENU.Volleyball]: 'VolleyBallData',
	[SPORTS_MENU.Badminton]: 'BadmintonData',
	[SPORTS_MENU.Cricket]: 'CricketData',
	[SPORTS_MENU.VirtualBasketball]: 'VirtualBasketBallData', // 193
};

export const resultService = {
	getResultIndexHeaderFormat,
	getResultIndexMatchFormat,
	getOutrightIndexHeaderFormat,
	getResultDetailDataFormat,
	getResultPopupDataFormat,
};